import React from 'react';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';

/**
 * Логотипы компаний-заказчиков.
 *
 * Секция сознательно не рендерится, пока массив пуст: пустая полоса с плейсхолдерами
 * хуже её отсутствия. Как только заказчик пришлёт логотипы — положить файлы
 * в ./img/clients и заполнить CLIENT_LOGOS.
 */
export const CLIENT_LOGOS = [];

const TrustLogos = () => {
    if (CLIENT_LOGOS.length === 0) return null;

    return (
        <section className={classes.section}>
            <div className={classes.trustInner}>
                <span className={classes.eyebrow}>
                    <IntlMessage id="coursesPage.trust.eyebrow"/>
                </span>
                <div className={classes.trustLogos}>
                    {CLIENT_LOGOS.map((logo) => (
                        <div className={classes.trustLogo} key={logo.alt}>
                            <img src={logo.src} alt={logo.alt}/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustLogos;
